module.exports = __webpack_public_path__ + "img/cp-12.e96ff762.jpg";